// extracted by mini-css-extract-plugin
export default {"container":"Fifth_container__08eC3","text":"Fifth_text__DsOXd","image":"Fifth_image__8TWAb","textContainer":"Fifth_textContainer__ld6zZ","justifiedText":"Fifth_justifiedText__jnaYQ"};